"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reduxThunk = _interopRequireDefault(require("redux-thunk"));

var _reactRedux = require("react-redux");

var _react2 = require("@prismicio/react");

var prismicH = _interopRequireWildcard(require("@prismicio/helpers"));

var _redux = require("redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _email = _interopRequireDefault(require("../reducers/email"));

var _prismic = _interopRequireDefault(require("../reducers/prismic"));

var _selectors = require("../selectors");

var _actions = require("../actions");

var _Programs = _interopRequireDefault(require("../components/Programs"));

var _SubmitButton = _interopRequireDefault(require("../components/SubmitButton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint-disable camelcase */
var mapStateToProps = function mapStateToProps(state) {
  return {
    recommendedPrograms: (0, _selectors.combinePrismicData)(state),
    emailState: state.email
  };
};

var PostPurchaseProgramRecommendations = /*#__PURE__*/function (_Component) {
  _inherits(PostPurchaseProgramRecommendations, _Component);

  var _super = _createSuper(PostPurchaseProgramRecommendations);

  function PostPurchaseProgramRecommendations() {
    var _this;

    _classCallCheck(this, PostPurchaseProgramRecommendations);

    _this = _super.call(this);
    _this.state = {
      selectedPrograms: {}
    };
    _this.emailPrograms = _this.emailPrograms.bind(_assertThisInitialized(_this));
    _this.selectProgram = _this.selectProgram.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(PostPurchaseProgramRecommendations, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          dispatch = _this$props.dispatch,
          eligiblePrograms = _this$props.eligiblePrograms,
          siteId = _this$props.siteId;

      if (eligiblePrograms && eligiblePrograms.programs && eligiblePrograms.programs.length > 0) {
        dispatch((0, _actions.fetchPrismicRecommendations)(siteId));
        dispatch((0, _actions.fetchPrismicPrograms)(siteId, eligiblePrograms.programs));
      }
    }
  }, {
    key: "selectProgram",
    value: function selectProgram(programId) {
      var selectedPrograms = this.state.selectedPrograms;
      selectedPrograms[programId] = !selectedPrograms[programId];
      this.setState({
        selectedPrograms: selectedPrograms
      });
    }
  }, {
    key: "emailPrograms",
    value: function emailPrograms() {
      var selectedPrograms = this.state.selectedPrograms;
      var _this$props2 = this.props,
          recommendedPrograms = _this$props2.recommendedPrograms,
          dispatch = _this$props2.dispatch,
          eligiblePrograms = _this$props2.eligiblePrograms,
          email = _this$props2.email,
          reportAction = _this$props2.reportAction;
      var emailUrl = eligiblePrograms.emailUrl;
      var programs = Object.keys(selectedPrograms).filter(function (programId) {
        return selectedPrograms[programId];
      });

      if (programs.length === 0) {
        programs = recommendedPrograms.programs.map(function (_ref) {
          var uid = _ref.uid;
          return uid;
        });
      }

      reportAction(programs);
      return dispatch((0, _actions.sendEmail)(emailUrl, email, programs));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          _this$props3$recommen = _this$props3.recommendedPrograms,
          header = _this$props3$recommen.header,
          programs = _this$props3$recommen.programs,
          cta_text = _this$props3$recommen.cta_text,
          programs_intro = _this$props3$recommen.programs_intro,
          _this$props3$emailSta = _this$props3.emailState,
          inFlight = _this$props3$emailSta.inFlight,
          success = _this$props3$emailSta.success,
          error = _this$props3$emailSta.error;
      var selectedPrograms = this.state.selectedPrograms;

      if (!(programs && programs.length > 0)) {
        return null;
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "recommended-programs"
      }, /*#__PURE__*/_react["default"].createElement("h1", {
        className: "recommended-programs__header"
      }, /*#__PURE__*/_react["default"].createElement(_react2.PrismicText, {
        field: header
      })), /*#__PURE__*/_react["default"].createElement("p", {
        className: "recommended-programs__info"
      }, /*#__PURE__*/_react["default"].createElement(_react2.PrismicText, {
        field: programs_intro
      })), /*#__PURE__*/_react["default"].createElement(_Programs["default"], {
        programs: programs,
        selectProgram: this.selectProgram,
        selectedPrograms: selectedPrograms
      }), /*#__PURE__*/_react["default"].createElement(_SubmitButton["default"], {
        error: error,
        inFlight: inFlight,
        emailPrograms: this.emailPrograms,
        ctaText: success ? 'Email sent!' : prismicH.asText(cta_text)
      }));
    }
  }], [{
    key: "getStore",
    value: function getStore() {
      var middleware = [_reduxThunk["default"]];
      return (0, _redux.createStore)((0, _redux.combineReducers)({
        prismic: _prismic["default"],
        email: _email["default"]
      }), _redux.applyMiddleware.apply(void 0, middleware));
    }
  }]);

  return PostPurchaseProgramRecommendations;
}(_react.Component);

PostPurchaseProgramRecommendations.propTypes = {
  siteId: _propTypes["default"].string.isRequired,
  email: _propTypes["default"].string.isRequired,
  eligiblePrograms: _propTypes["default"].shape({}),
  reportAction: _propTypes["default"].func.isRequired,
  dispatch: _propTypes["default"].func.isRequired,
  emailState: _propTypes["default"].shape({}).isRequired,
  recommendedPrograms: _propTypes["default"].shape({}).isRequired
};
PostPurchaseProgramRecommendations.defaultProps = {
  eligiblePrograms: {}
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(PostPurchaseProgramRecommendations);

exports["default"] = _default;